import { render, staticRenderFns } from "./termAndPrivacy.vue?vue&type=template&id=eb185c6a&scoped=true"
import script from "./termAndPrivacy.vue?vue&type=script&lang=js"
export * from "./termAndPrivacy.vue?vue&type=script&lang=js"
import style0 from "./termAndPrivacy.vue?vue&type=style&index=0&id=eb185c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb185c6a",
  null
  
)

export default component.exports